import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LoadingSpinner } from '../common/LoadingSpinner';

interface FeatureProtectedRouteProps {
  featureCode: string;
  children: React.ReactNode;
}

// Feature 011 (FR-002, FR-048, research §9). Admin bypasses; Editors with the
// matching code render the children; everyone else is bounced to /forbidden.
// This is cosmetic — the server-side [RequireFeature] enforces SC-004.
export function FeatureProtectedRoute({ featureCode, children }: FeatureProtectedRouteProps) {
  const { isAuthenticated, isLoading, user, accessibleFeatures } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'Admin') {
    return <>{children}</>;
  }

  if (accessibleFeatures.some(f => f.code === featureCode)) {
    return <>{children}</>;
  }

  return <Navigate to="/forbidden" replace />;
}
